<div class="connection-expired-modal" data-testid="connection-expired-overlay">
  <div class="connection-expired-modal__card">
    <div class="connection-expired-modal__content">
      <p class="connection-expired-modal__title" data-testid="modal-title">
        {{ 'CONNECTION_EXPIRED_MODAL.TITLE' | translate }}
      </p>
    </div>

    <div class="connection-expired-modal__footer">
      <ask-button-v2
        appearance="brand"
        shape="square"
        (onClick)="onReload()"
        data-testid="reload-button"
      >
        <app-icon name="refresh" [size]="20"></app-icon>
        {{ 'CONNECTION_EXPIRED_MODAL.BUTTON' | translate }}
      </ask-button-v2>
    </div>
  </div>
</div>
